export default "__VITE_ASSET__0d9990fd__"